import { render, staticRenderFns } from "./tempSSPAFasa2.vue?vue&type=template&id=1d41f7e0&scoped=true&"
import script from "./tempSSPAFasa2.vue?vue&type=script&lang=js&"
export * from "./tempSSPAFasa2.vue?vue&type=script&lang=js&"
import style0 from "./tempSSPAFasa2.vue?vue&type=style&index=0&id=1d41f7e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d41f7e0",
  null
  
)

export default component.exports